<template>
  <div style="width: 100%;height: 100%">
    <el-scrollbar style="height: 100%">
      <div style="font-size: 26px;font-weight: bolder;margin-left: 50%;height: 6%;margin-bottom: 2%">项目基本情况</div>
      <div style="width: 100%;">
        <el-form ref="form" :model="formData" label-width="165px" :rules="rules">
          <el-form-item label="项目名称" prop="name">
            <el-input :readonly="isDisabled" v-model="formData.name"></el-input>
          </el-form-item>
          <el-form-item label="申报等级" prop="grade">
<!--            <el-input :readonly="isDisabled" v-model="formData.grade"></el-input>-->
            <el-select :disabled="isDisabled" v-model="formData.grade" filterable style="width: 100%">
              <el-option v-for="item in gradeOptions"
                         :label="item.word"
                         :key="item.word"
                         :value="item.word"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="奖励类别" prop="awardtype">
<!--            <el-input :readonly="isDisabled" v-model="formData.awardtype"></el-input>-->
            <el-select :disabled="isDisabled" v-model="formData.awardtype" filterable style="width: 100%">
              <el-option v-for="item in awardtypeOptions"
                         :label="item.word"
                         :key="item.word"
                         :value="item.word"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主要完成人" prop="people">
            <el-input :readonly="isDisabled" v-model="formData.people" placeholder="多个完成人请以、分隔"></el-input>
          </el-form-item>
          <el-form-item label="主要完成单位" prop="finishunit">
            <el-input :readonly="isDisabled" v-model="formData.finishunit" placeholder="多个完成单位请以、分隔"></el-input>
          </el-form-item>
          <el-form-item label="推荐单位" prop="unit">
            <el-input :readonly="isDisabled" v-model="formData.unit"></el-input>
          </el-form-item>
          <el-form-item label="学科分类名称" prop="subjectList">
            <el-select :disabled="isDisabled" v-model="formData.subjectList" value-key="code" multiple filterable style="width: 100%">
              <el-option v-for="item in subjectOptions"
                         :label="item.subjectname+'(代码：'+item.code+')'"
                         :key="item.code"
                         :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="任务来源" prop="tasksource">
<!--            <el-input :readonly="isDisabled" v-model="formData.tasksource"></el-input>-->
            <el-select :disabled="isDisabled" v-model="formData.tasksource" filterable style="width: 100%">
              <el-option v-for="item in tasksourceOptions"
                         :label="item.word"
                         :key="item.word"
                         :value="item.word"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="立项计划的名称和编号" prop="projectnameandcode">
            <el-input :readonly="isDisabled" v-model="formData.projectnameandcode" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="鉴定（验收）文件编号" prop="checkcode">
            <el-input :readonly="isDisabled" v-model="formData.checkcode" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="项目起止时间" required>
            <el-form-item style="display: inline-block;width: 48%" prop="projectstartdate">
              <el-date-picker
                :readonly="isDisabled"
                style="width: 100%"
                v-model="formData.projectstartdate"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            -
            <el-form-item style="display: inline-block;width: 49.5%" prop="projectenddate">
              <el-date-picker
                :readonly="isDisabled"
                style="width: 100%"
                v-model="formData.projectenddate"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-form-item>
        </el-form>
        <div v-if="!isDisabled" style="width: 100%;">
          <el-button type="info" @click="onReset" style="margin-left: 49.3%">重置</el-button>
          <el-button type="primary" @click="onSubmit" :disabled="isDisabledSubmit">保存</el-button>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import utils from "@/views/js/utils";

export default {
  name: "PrimaryInfo_01",
  data() {
    let checkPeople = (rule, value, callback) => {
      if(!(/^([\u4E00-\u9FA5a-zA-Z\d]+、*)+$/.test(value))){
          callback(new Error('多个完成人请以、分隔'))
        }else {
        callback();
      }
    }
    let checkFinishunit = (rule, value, callback) => {
      if(!(/^([\u4E00-\u9FA5a-zA-Z\d]+、*)+$/.test(value))){
          callback(new Error('多个完成单位请以、分隔'))
        }else {
        callback();
      }
    }
    return {
      queryDate: {
        openWith: ''
      },
      createuserid: sessionStorage.getItem('createuserid'),
      isDisabled: sessionStorage.getItem('openWith')=='readOnly' ? true : false,
      formData: {
        name: '',
        grade: '',
        awardtype: '',
        people: '',
        finishunit: '',
        unit: '',
        subjectList: [],
        tasksource: '',
        projectnameandcode: '',
        checkcode: '',
        projectstartdate: '',
        projectenddate: '',
      },
      subjectOptions: [],
      gradeOptions:[],
      awardtypeOptions:[],
      tasksourceOptions:[],
      rules:{
        name: { required: true, message: ' ', trigger: 'blur' },
        grade: { required: true, message: ' ', trigger: 'blur' },
        awardtype: { required: true, message: ' ', trigger: 'blur' },
        // people: { required: true, trigger: 'blur',validator:checkPeople},
        // finishunit: { required: true,  trigger: 'blur' ,validator:checkFinishunit},
        people: { required: true, message: ' ', trigger: 'blur'},
        finishunit: { required: true, message: ' ',  trigger: 'blur'},
        unit: { required: true, message: ' ', trigger: 'blur' },
        subjectList: { required: true, message: ' ', trigger: 'blur' },
        tasksource: { required: true, message: ' ', trigger: 'blur' },
        projectnameandcode: { required: true, message: ' ', trigger: 'blur' },
        checkcode: { required: true, message: ' ', trigger: 'blur' },
        projectstartdate: { required: true, message: ' ', trigger: 'blur' },
        projectenddate: { required: true, message: ' ', trigger: 'blur' },
      },
      isDisabledSubmit:false
    }
  },
  methods: {
    getData() {
      if (sessionStorage.getItem("pbcid") == undefined) {
        return
      }
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/common/selectproject',
        params: {
          pbcid: Number(sessionStorage.getItem('pbcid'))
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.formData = resp.data
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    getSubjectOptions() {
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/user/selectsubject',
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.subjectOptions = resp.data
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    getGradeOptions(){
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/user/selectdictionaries',
        params:{
          state:1
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.gradeOptions = resp.data
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    getAwardtypeOptions(){
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/user/selectdictionaries',
        params:{
          state:2
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.awardtypeOptions = resp.data
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    getTasksourceOptions(){
      this.$axios({
        method: 'get',
        url: this.GLOBAL.URL + 'pingjiang/user/selectdictionaries',
        params:{
          state:3
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        if (resp.code == 1000) {
          this.tasksourceOptions = resp.data
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    onSubmit(){
      this.$refs["form"].validate((valid) => {
          if (valid) {
            if(sessionStorage.getItem('pbcid')==undefined){
              this.onSaveSubmit()
            }else{
              this.onEditSubmit()
            }
          }
      })
    },
    onSaveSubmit() {
      this.openLoading("内容提交中","提交失败，请检查网络",7000)
      // this.isDisabledSubmit=true
      this.$axios({
        method: 'post',
        url: this.GLOBAL.URL + 'pingjiang/user/addproject',
        data: {
          userid: sessionStorage.getItem("userid"),
          name: this.formData.name,
          grade: this.formData.grade,
          awardtype: this.formData.awardtype,
          people: this.formData.people,
          finishunit: this.formData.finishunit,
          unit: this.formData.unit,
          subjectDTOList: this.formData.subjectList,
          tasksource: this.formData.tasksource,
          projectnameandcode: this.formData.projectnameandcode,
          checkcode: this.formData.checkcode,
          projectstartdate: this.formData.projectstartdate,
          projectenddate: this.formData.projectenddate,
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        this.closeLoading()
        if (resp.code == 1000) {
          this.showSuccessMsg(resp.message)
          sessionStorage.setItem('pbcid', resp.data)
          // this.isDisabledSubmit=false
        } else {
          this.showFailMsg(resp.message)
          // this.isDisabledSubmit=false
        }
      })
    },
    onEditSubmit() {
      this.openLoading("内容提交中","提交失败，请检查网络",7000)
      // this.isDisabledSubmit=true
      this.$axios({
        method: 'post',
        url: this.GLOBAL.URL + 'pingjiang/user/updateproject',
        data: {
          pbcid: sessionStorage.getItem("pbcid"),
          name: this.formData.name,
          grade: this.formData.grade,
          awardtype: this.formData.awardtype,
          people: this.formData.people,
          finishunit: this.formData.finishunit,
          unit: this.formData.unit,
          subjectList: this.formData.subjectList,
          tasksource: this.formData.tasksource,
          projectnameandcode: this.formData.projectnameandcode,
          checkcode: this.formData.checkcode,
          projectstartdate: this.formData.projectstartdate,
          projectenddate: this.formData.projectenddate,
        }
      }).then(res => {
        let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
        // this.isDisabledSubmit=false
        this.closeLoading()
        if (resp.code == 1000) {
          this.showSuccessMsg(resp.message)
        } else {
          this.showFailMsg(resp.message)
        }
      })
    },
    onReset() {
      Object.assign(this.formData, this.$options.data().formData)
    }
  },
  created() {
    this.getData()
    this.getSubjectOptions()
    this.getGradeOptions()
    this.getAwardtypeOptions()
    this.getTasksourceOptions()
  }
}
</script>
<style scoped>
/deep/ .el-scrollbar__wrap {
  overflow: hidden scroll;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/PJGL/ProjectSequence/PrimaryInfo_01.vue